import React from 'react';
import PropTypes from 'prop-types';
import ResultLink from '../../shared/links/ResultLink';
import { formatDate } from '../../utils/date';

/**
 * Last cell for Seven-Day Winners table on Signposts Tab
 */
const WonCell = ({
    courseStyleName,
    courseUid,
    raceDatetime,
    raceInstanceUid,
    raceInstanceTitle,
}) => (
    <span>
        {courseStyleName}
        &nbsp;
        <ResultLink
            courseUid={courseUid}
            courseName={courseStyleName}
            raceDatetime={raceDatetime}
            raceInstanceUid={raceInstanceUid}
            raceInstanceTitle={raceInstanceTitle}
        >
            {formatDate(raceDatetime, 'h:mm')}
        </ResultLink>
        &nbsp;
        {formatDate(raceDatetime, 'DDMMMYY')}
    </span>
);

WonCell.propTypes = {
    courseStyleName: PropTypes.string,
    courseUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    raceInstanceUid: PropTypes.number,
    raceInstanceTitle: PropTypes.string,
};

export default WonCell;



// WEBPACK FOOTER //
// ./src/js/course/signposts/WonCell.jsx